import EG from 'country-flag-icons/react/3x2/EG';
import SA from 'country-flag-icons/react/3x2/SA';
import './country-flag.css';

const flagsByCountry = {
    Egypt: EG,
    'Saudi Arabia': SA,
} as const;

export type FlagCountry = keyof typeof flagsByCountry;

interface CountryFlagProps {
    country: FlagCountry;
    className?: string;
}

export const CountryFlag = ({ country, className }: CountryFlagProps) => {
    const Flag = flagsByCountry[country];

    return (
        <Flag
            className={className ? `country-flag ${className}` : 'country-flag'}
            aria-hidden="true"
        />
    );
};
